


<div class="module-content-panel">
  <ng-container *ngTemplateOutlet="titleHidden ? listTmp : expansionPanelTmp"></ng-container>
</div>

<ng-template #listTmp>
  <div class="contents-list">
    @for (child of contents; track child) {
      <lib-content-card
        [item]="child"
        (click)="navigate(child)">
      </lib-content-card>
    }

    @if (isLoading) {
      @for (item of placeholders; track $index) {
        <lib-skeleton-loader
          class="skeleton-card"
          >
        </lib-skeleton-loader>
      }
    }
  </div>
</ng-template>

<ng-template #expansionPanelTmp>
  <mat-expansion-panel class="content-group" (afterExpand)="loadContents()">
    <mat-expansion-panel-header>
      <div class="panel-header">
        {{ title }}
        <span class="child-content-indicator">
          @if (lessonsCount) {
            {{ 'COMMON.lessons_count' | translate : { count: lessonsCount } }}
          }

          @if (lessonsCount && quizzesCount) {
            &
          }

          @if (quizzesCount) {
            {{ 'COMMON.quizzes_count' | translate : { count: quizzesCount } }}
          }
        </span>
      </div>
    </mat-expansion-panel-header>

    <ng-container *ngTemplateOutlet="listTmp"></ng-container>
  </mat-expansion-panel>
</ng-template>
